export const loginRoutes = [
  {
    name: 'login',
    path: '/login',
    component: () => import('@/modules/log-in/views/LoginView.vue')
  }
]
